export const copyToClipboard = (textToCopy: string) => {
  const isFirefox = window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

  if (!isFirefox) {
    // Check if permissions API is available and try to query clipboard-write permission
    if (window.navigator.permissions?.query) {
      window.navigator.permissions
        .query({ name: 'clipboard-write' as PermissionName })
        .then(result => {
          if (result.state == 'granted' || result.state == 'prompt') {
            copyTextToClipboard(textToCopy);
          } else {
            window.alert('Write access to clipboard not granted!');
          }
        })
        .catch(() => {
          // If permissions query fails (due to permissions policy), try to copy anyway
          copyTextToClipboard(textToCopy);
        });
    } else {
      // If permissions API is not available, try to copy anyway
      copyTextToClipboard(textToCopy);
    }
  } else {
    copyTextToClipboard(textToCopy);
  }
};

const copyTextToClipboard = (textToCopy: string): void => {
  const textArea = createTemporaryTextArea();
  textArea.value = textToCopy;
  document.body.appendChild(textArea);
  textArea.select();
  textArea.setSelectionRange(0, 99999); // note: for mobile devices

  try {
    if (!window.navigator.clipboard) {
      // execCommand is deprecated but still needed for older browsers as fallback
      document.execCommand('copy');
    } else {
      window.navigator.clipboard.writeText(textToCopy).catch(() => {
        // Fallback to execCommand if clipboard API fails
        // execCommand is deprecated but still needed for older browsers as fallback
        document.execCommand('copy');
      });
    }
  } catch (error) {
    // If both methods fail, try the fallback approach
    try {
      // execCommand is deprecated but still needed for older browsers as final fallback
      document.execCommand('copy');
    } catch (fallbackError) {
      console.error('Failed to copy text to clipboard:', fallbackError);
    }
  }

  textArea.remove();
};

const createTemporaryTextArea = (): HTMLTextAreaElement => {
  const textArea = document.createElement('textarea');
  textArea.style.position = 'absolute';
  textArea.style.left = '-9969px';
  textArea.setAttribute('readonly', 'readonly');
  return textArea;
};
